<template>
  <div class="modal__wrap--bg cmp-modal" :class="{'is-active': annPreViewModal}" id="ann-view-template">
    <div class="modal-wrap-container modal-wd1020">
      <div class="modal-header">
        <div class="title">공고 미리보기</div>
      </div>
      <div class="modal-body-container ht-full mt-40 sticky">
        <div class="box-community-top box-type">
          <div class="job-title-info">
            <div class="tit">{{ result.ANN_NM }}</div>
            <div class="description mt-16">{{ result.INTRO }}</div>
          </div>
        </div>

        <div class="cont-section mt-0">
          <div class="h3-title font-bold mt-40">기본정보</div>
          <div class="table-wrap">
            <table class="table-body-only">
              <caption>기본정보 표</caption>
              <colgroup class="pc-cell">
                <col style="width: 160px;" />
                <col />
              </colgroup>
              <colgroup class="mo-cell">
                <col style="width: 88px;" />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">업직종</th>
                  <td>{{ result.OCCUPATION_LABEL }}</td>
                </tr>
                <tr>
                  <th scope="row">모집대상</th>
                  <td>{{ result.RCRT_SE_NM }}</td>
                </tr>
                <tr>
                  <th scope="row">모집인원</th>
                  <td>{{ result.RCRT_PPL }}명</td>
                </tr>
                <tr>
                  <th scope="row">모집기간</th>
                  <td>{{ result.APPDURNG_ST }} {{ result.APPDURNG_ST_TM }}시 ~ {{ result.APPDURNG_ED }} {{ result.APPDURNG_ED_TM }}시</td>
                </tr>
                <tr>
                  <th scope="row">합격자 발표일</th>
                  <td>{{ result.PASS_DAY }}</td>
                </tr>
                <tr>
                  <th scope="row">문의 <br class="mo-only">연락처</th>
                  <td>{{ result.TEL_1 }} - {{ result.TEL_2 }} - {{ result.TEL_3 }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="cont-section mt-0">
          <div class="h3-title  font-bold mt-40">활동조건</div>
          <div class="table-wrap">
            <table class="table-body-only">
              <caption>활동조건 표</caption>
              <colgroup class="pc-cell">
                <col style="width: 160px;" />
                <col />
              </colgroup>
              <colgroup class="mo-cell">
                <col style="width: 88px;" />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">나이</th>
                  <td>{{ result.AGE }}~{{result.AGE_TO}} {{ result.AGE_DESC }}</td>
                </tr>
                <tr>
                  <th scope="row">거주지</th>
                  <td>{{ result.RESIDENCE }}</td>
                </tr>
                <tr>
                  <th scope="row">경력사항</th>
                  <td>{{ result.CAREER_HISTORY_LABEL }}</td>
                </tr>
                <tr>
                  <th scope="row">필수역량</th>
                  <td>{{ result.REQ_COMPETENCE }}</td>
                </tr>
                <tr>
                  <th scope="row">우대조건</th>
                  <td>{{ result.PREF_CONDITIONS }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="cont-section mt-0">
          <div class="h3-title font-bold mt-40">직무정보</div>
          <div class="table-wrap">
            <table class="table-body-only">
              <caption>직무정보 표</caption>
              <colgroup class="pc-cell">
                <col style="width: 160px;" />
                <col />
              </colgroup>
              <colgroup class="mo-cell">
                <col style="width: 88px;" />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">직무명</th>
                  <td>{{ result.JOB_NAME }}</td>
                </tr>
                <tr>
                  <th scope="row">담당업무</th>
                  <td>{{ result.DUTIES }}</td>
                </tr>
                <tr>
                  <th scope="row">소속 및<br class="mo-only"> 직책</th>
                  <td>{{ occupationAndPosition }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="cont-section mt-0">
          <div class="h3-title font-bold mt-40">활동환경</div>
          <div class="table-wrap">
            <table class="table-body-only">
              <caption>활동환경 표</caption>
              <colgroup class="pc-cell">
                <col style="width: 160px;" />
                <col />
              </colgroup>
              <colgroup class="mo-cell">
                <col style="width: 88px;" />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">시급</th>
                  <td>{{ payCondition }}원</td>
                </tr>
                <!-- <tr>
                  <th scope="row">월급</th>
                  <td>250만원 이상 (면접 시 협의)</td>
                </tr>
                <tr>
                  <th scope="row">추가비용</th>
                  <td>1. 연수비 50,000원</td>
                </tr> -->
                <tr>
                  <th scope="row">급여조건 <br class="mo-only"> 추가 <br class="mo-only">설명</th>
                  <td>{{ result.PAY_CONDITION }}</td>
                </tr>
                <tr>
                  <th scope="row">활동기간</th>
                  <td>{{ actperPeriod }}</td>
                </tr>
                <!-- <tr>
                  <th scope="row">활동시간</th>
                  <td>09:30 ~ 18:30 / 휴게시간: 12:30~13:30</td>
                </tr> -->
                <tr>
                  <th scope="row">근무형태</th>
                  <td>{{ result.WORK_CONDITION_LABEL }}</td>
                </tr>
                <tr>
                  <th scope="row">활동처</th>
                  <td>{{ result.LOCATION }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- <div class="cont-section mt-0">
          <div class="h3-title  font-bold mt-40">진행절차</div>
          <div class="table-wrap">
            <table class="table-body-only">
              <caption>진행절차 표</caption>
              <colgroup class="pc-cell">
                <col style="width: 160px;" />
                <col />
              </colgroup>
              <colgroup class="mo-cell">
                <col style="width: 88px;" />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">신청방법</th>
                  <td>
                    <ul>
                      <li>행사신청, 구직등록 및 입사지원 모두 진행해야 참여 가능</li>
                      <li>1. 행사신청: 50+포털 회원가입 후 해당 공고에 '신청하기'</li>
                      <li>2. 구직등록 및 입사지원: 고용24(워크넷) '구직등록' 후 '입사지원'</li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <th scope="row">채용절차</th>
                  <td>참여자 모집 → 적격검토 → 서류 및 면접 심사 → 합격자 발표</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div> -->

        <!-- <div class="cont-section mt-0">
          <div class="h3-title font-bold mt-40">행사일정</div>
          <div class="table-wrap">
            <table class="table-body-only">
              <caption>행사일정 표</caption>
              <colgroup class="pc-cell">
                <col style="width: 160px;" />
                <col />
              </colgroup>
              <colgroup class="mo-cell">
                <col style="width: 88px;" />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">일시</th>
                  <td>2025. 6. 18(수) 14:00 ~</td>
                </tr>
                <tr>
                  <th scope="row">장소</th>
                  <td>서울고용센터 1층 청년On라운지</td>
                </tr>
                <tr>
                  <th scope="row">구비서류</th>
                  <td>당일 현장 면접 희망 시 구직등록 후 이력서(자율양식) 지참</td>
                </tr>
                <tr>
                  <th scope="row">세부일정</th>
                  <td>
                    <strong>1. 채용설명회</strong><br>
                    14:00 - 14:05 운영기관 소개<br>
                    14:05 - 14:25 채용기업 소개 및 직무 설명<br>
                    14:25 - 14:45 질의 응답<br>
                    14:45 - 14:50 쉬는 시간<br>
                    <strong>2. 현장 면접</strong>
                    14:50 - 종료 시 - 채용 담당자-참여자 면접 진행
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div> -->
        <!-- <div class="cont-section mt-0">
          <div class="h3-title font-bold mt-40">기관정보</div>
          <div class="table-wrap">
            <table class="table-body-only">
              <caption>기관정보 표</caption>
              <colgroup class="pc-cell">
                <col style="width: 160px;" />
                <col />
              </colgroup>
              <colgroup class="mo-cell">
                <col style="width: 88px;" />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">운영기관</th>
                  <td>남부캠퍼스, 중부캠퍼스</td>
                </tr>
                <tr>
                  <th scope="row">운영기관<br class="mo-only">연락처</th>
                  <td>02-460-5309</td>
                </tr>
                <tr>
                  <th scope="row">운영기관<br class="mo-only">담당부서</th>
                  <td>남부캠퍼스</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div> -->

        <div class="cont-section mt-0">
          <div class="h3-title font-bold mt-40">협력기관(기업) 정보</div>
          <div class="table-wrap">
            <table class="table-body-only">
              <caption>협력기관(기업) 정보 표</caption>
              <colgroup class="pc-cell">
                <col style="width: 160px;" />
                <col />
              </colgroup>
              <colgroup class="mo-cell">
                <col style="width: 88px;" />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">협력 <br class="mo-only">기관명</th>
                  <td>{{ result.CORPR_ORG }}</td>
                </tr>
                <tr>
                  <th scope="row">소개</th>
                  <td>{{ result.PARTNER_INTRO }}</td>
                </tr>
                <tr>
                  <th scope="row">조직구성 <br class="mo-only">및 특징</th>
                  <td>{{ result.PARTNER_FEATURE }}</td>
                </tr>
                <tr>
                  <th scope="row">주요 사업</th>
                  <td>{{ result.PARTNER_BUSINESS }}</td>
                </tr>
                <tr>
                  <th scope="row">주소</th>
                  <td>{{ result.PARTNER_POST }}<br>{{ result.PARTNER_ADDR1 }}<br>{{ result.PARTNER_ADDR2 }}</td>
                </tr>
                <tr>
                  <th scope="row">협력기관 <br class="mo-only">담당자</th>
                  <td>{{ result.PARTNER_MANAGER }}</td>
                </tr>
                <tr>
                  <th scope="row">협력기관<br class="mo-only"> 연락처</th>
                  <td>{{ result.PARTNER_TEL }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- <div class="cont-section mt-0">
          <div class="h3-title font-bold mt-40">사전 교육 여부</div>
          <div class="table-wrap">
            <table class="table-body-only">
              <caption>사전 교육 여부 표</caption>
              <colgroup class="pc-cell">
                <col style="width: 160px;" />
                <col />
              </colgroup>
              <colgroup class="mo-cell">
                <col style="width: 88px;" />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">사전 <br class="mo-only">교육 <br class="mo-only"> 여부</th>
                  <td>있음</td>
                </tr>
                <tr>
                  <th scope="row">교육기간</th>
                  <td>2025-05-28 ~ 2025-05-29</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div> -->

        <!-- <div class="cont-section mt-0">
          <div class="h3-title font-bold mt-40">연계 교육 정보</div>
          <div class="table-wrap">
            <table class="table-body-only">
              <caption>연계 교육 정보 표</caption>
              <colgroup class="pc-cell">
                <col style="width: 160px;" />
                <col />
              </colgroup>
              <colgroup class="mo-cell">
                <col style="width: 88px;" />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">필수 <br class="mo-only">연계 <br class="mo-only">강화</th>
                  <td>
                    <ul>
                      <li>[영상] AI 영상 편집 제작</li>
                      <li>콘텐츠 제작에 필요한 편집 기술 실기 과정</li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <th scope="row">우대 <br class="mo-only">수료 <br class="mo-only">강화</th>
                  <td>
                    <ul>
                      <li>[영상] AI 영상 편집 제작</li>
                      <li>콘텐츠 제작에 필요한 편집 기술 실기 과정</li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div> -->

        <!-- <div class="cont-section mt-0">
          <div class="h3-title font-bold mt-40">첨부파일</div>
          <div class="table-wrap">
            <table class="table-body-only">
              <caption>첨부파일 표</caption>
              <colgroup class="pc-cell">
                <col style="width: 160px;" />
                <col />
              </colgroup>
              <colgroup class="mo-cell">
                <col style="width: 88px;" />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">첨부파일</th>
                  <td>
                    <a href="#" class="attachment-link" title="(2025.5.15.)중장년 경력 인재 지원(채용형) 참여자 모집 변경공고문.pdf">(2025.5.15.)중장년 경력 인재 지원(채용형) 참여자 모집 변경공고문.pdf</a>
                    <a href="#" class="attachment-link" title="(양식) 권역별 매칭데이 구직자 이력서 양식.hwp">(양식) 권역별 매칭데이 구직자 이력서 양식.hwp</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div> -->

        <div class="cont-section mt-0">
          <div class="h3-title font-bold mt-40">공고 내용</div>
          <div class="table-wrap">
            <table class="table-body-only">
              <caption>공고 내용 표</caption>
              <colgroup class="pc-cell">
                <col style="width: 160px;" />
                <col />
              </colgroup>
              <colgroup class="mo-cell">
                <col style="width: 88px;" />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <td colspan="2">
                    <div class="editor-content-area mt-0" v-html="result.ANN_DTL_DESC"></div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">연관 <br class="mo-only">키워드</th>
                  <td>{{ result.KWD }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-md button-wid150" @click="close">
          닫기
        </button>
      </div>
      <button type="button" class="btn btn-close only-icon" aria-label="닫기" @click="close" title="닫기">
        <i class="ico ico-x-bl"></i>
      </button>
    </div>
  </div>
</template>

<script>
import Axios from 'axios';

export default {
  name: 'ann-view-template',
  props: ['annPreViewModal', 'annNo'],
  components: {},
  data() {
    return {
      result: {},
      resultAttachFile: [],
    };
  },
  watch: {
    annPreViewModal: {
      handler(newVal) {
        if (newVal) this.getData();
      },
    },
  },
  computed: {
    occupationAndPosition() {
      let msg = this.result.occupationLabel;
      if (msg !== '' && this.result.position !== '') msg += ' / ';
      msg += this.result.position;
      return msg;
    },
    payCondition() {
      return (!this.result.PAY_CONDITION) ? 0 : this.result.PAY_CONDITION.toLocaleString();
    },
    actperPeriod() {
      if (!this.result.ACTPER_ST && !this.result.ACTPER_ED) {
        return '기간의 정함이 없음';
      }
      return `${this.result.ACTPER_ST} ~ ${this.result.ACTPER_ED}`;
    },
  },
  methods: {
    initializeData() {},
    close() {
      $('body').removeClass('modal-open');
      this.initializeData();
      this.$emit('update:annPreViewModal', false);
    },
    getData() {
      const params = { ANN_NO: this.annNo };
      Axios.get('/api/comp/recannDetail', { params }).then((res) => {
        console.log(res.data);
        const occupationLabel = (!this.result.OCCUPATION_LABEL) ? '' : this.result.OCCUPATION_LABEL;
        const position = (!this.result.POSITION) ? '' : this.result.POSITION;
        this.result = {
          ...res.data.result,
          occupationLabel,
          position,
        };
      }).catch((error) => {
        console.log(error.data);
      });
    },
  },
  mounted() {},
};
</script>


// WEBPACK FOOTER //
// AnnPreView.vue?13a6e918